var map = {
	"./_bdf0da5e-55ed-4f22-955a-394cb4ab7bf9.jpg": 459,
	"./art1.png": 440,
	"./art2.png": 291,
	"./brand-ice-cream.png": 622,
	"./cart.png": 838,
	"./delivery.png": 636,
	"./discout.png": 395,
	"./div-2.png": 566,
	"./divider.png": 937,
	"./no-item.png": 729,
	"./package.png": 954,
	"./service1.jpg": 818,
	"./service2.jpg": 717,
	"./service3.jpg": 136,
	"./service4.jpg": 67,
	"./service5.jpg": 902,
	"./service6.jpg": 833,
	"./service7.jpg": 788,
	"./star-blank.png": 357,
	"./star-filled.png": 951,
	"./tag.png": 354,
	"./test.png": 132,
	"./thankyou.png": 253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 958;